import Translations from '../Translations';
import React from 'react';
import {PAYMENT_METHOD} from '../../utils/payment';

const METHODS = [
    [PAYMENT_METHOD.FLEX_WALLET_DEDUCTION, 'Flex Wallet Deduction', 'selection.payment_method_flex_wallet'],
    [PAYMENT_METHOD.SALARY_DEDUCTION, 'Salary Deduction', 'selection.payment_method_salary'],
];

const PaymentMethod = ({value, disabled, onChange}) => (
    <Translations text="selection.payment_method_title" backup="Select Payment Method" render={heading => (
    <section className="payment-method" aria-label={heading}>
        <h3><Translations text="selection.payment_method_title" backup={"Select Payment Method"} /></h3>
        <div role="radiogroup" aria-label={heading}>
            {METHODS.map(([method, label, key]) => (
                <label key={method} className={`payment-method-choice ${value === method ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}>
                    <input
                        type="radio"
                        name="payment-method"
                        value={method}
                        checked={value === method}
                        disabled={disabled}
                        onChange={() => onChange(method)}
                    />
                    <span><Translations text={key} backup={label} /></span>
                </label>
            ))}
        </div>
    </section>
    )} />
);

export default PaymentMethod;
